import { calculateTrigonmetricDistance } from "@nova/calculate-geospatial"

type Coordinate = { latitude: number; longitude: number }

export type PolygonResult = {
    svgPoints: string
    boundingBox: {
        widthFeet: number
        heightFeet: number
        minLat: number
        maxLat: number
        minLng: number
        maxLng: number
    }
}

const METERS_TO_FEET = 3.28084

export function processPolygon(points: Coordinate[]): PolygonResult | null {
    if (points.length < 3) return null

    let minLat = points[0].latitude
    let maxLat = points[0].latitude
    let minLng = points[0].longitude
    let maxLng = points[0].longitude

    for (let i = 1; i < points.length; i++) {
        const { latitude, longitude } = points[i]
        if (latitude < minLat) minLat = latitude
        if (latitude > maxLat) maxLat = latitude
        if (longitude < minLng) minLng = longitude
        if (longitude > maxLng) maxLng = longitude
    }

    const widthMeters = calculateTrigonmetricDistance(
        { latitude: minLat, longitude: minLng },
        { latitude: minLat, longitude: maxLng }
    )

    const heightMeters = calculateTrigonmetricDistance(
        { latitude: minLat, longitude: minLng },
        { latitude: maxLat, longitude: minLng }
    )

    const widthFeet = widthMeters * METERS_TO_FEET
    const heightFeet = heightMeters * METERS_TO_FEET

    const latRange = maxLat - minLat || 1
    const lngRange = maxLng - minLng || 1

    const scale = Math.min(24 / (widthMeters || 1), 24 / (heightMeters || 1))

    const svgCoords = points.map((p) => {
        const relX = (p.longitude - minLng) / lngRange
        const relY = (p.latitude - minLat) / latRange

        const x = relX * widthMeters * scale + 1
        const y = relY * heightMeters * scale

        return `${Math.round(x * 10) / 10},${Math.round(y * 10) / 10}`
    })

    return {
        svgPoints: svgCoords.join(" "),
        boundingBox: {
            widthFeet: widthFeet,
            heightFeet: heightFeet,
            minLat,
            maxLat,
            minLng,
            maxLng,
        },
    }
}
